/**
 * TransactionFormSkeleton - Fast loading skeleton for form page
 */

import { Skeleton } from '../../../components/ui/skeleton';
import { Card } from '../../../components/ui/card';
import { Container, Stack } from '../../../components/primitives';

export function TransactionFormSkeleton() {
  return (
    <Container size="large" className="py-6 md:py-8">
      <Stack spacing="large">
        {/* Header Skeleton */}
        <div className="space-y-3">
          <div className="flex items-start justify-between">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-96 max-w-full" />
            </div>
            <Skeleton className="h-10 w-24" />
          </div>
        </div>

        {/* Tips Card Skeleton */}
        <Card className="p-4 border-primary/50">
          <div className="flex gap-3">
            <Skeleton className="h-5 w-5 rounded shrink-0" />
            <div className="space-y-2 flex-1">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-3/4" />
            </div>
          </div>
        </Card>

        {/* Basic Info Card */}
        <Card className="p-6 border-2">
          <div className="space-y-6">
            {/* Type selector */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-32" />
              <div className="grid grid-cols-3 gap-3">
                <Skeleton className="h-24 rounded-xl" />
                <Skeleton className="h-24 rounded-xl" />
                <Skeleton className="h-24 rounded-xl" />
              </div>
            </div>

            {/* Amount */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-16 w-full" />
            </div>

            {/* Description */}
            <div className="space-y-3">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-12 w-full" />
            </div>
          </div>
        </Card>

        {/* Status Card */}
        <Card className="p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-6 w-24" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <Skeleton className="h-14 rounded-lg" />
              <Skeleton className="h-14 rounded-lg" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
              <Skeleton className="h-10 w-full" />
            </div>
          </div>
        </Card>

        {/* Accordions */}
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} className="p-6 border-2">
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-lg" />
                <div className="space-y-2 flex-1">
                  <Skeleton className="h-4 w-40" />
                  <Skeleton className="h-3 w-56" />
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Actions */}
        <Card className="p-6 border-2">
          <div className="flex justify-between items-center">
            <Skeleton className="h-4 w-32" />
            <div className="flex gap-2">
              <Skeleton className="h-10 w-24" />
              <Skeleton className="h-10 w-32" />
            </div>
          </div>
        </Card>
      </Stack>
    </Container>
  );
}
